import { object, string } from "yup";

import { PreciselyAddressWithUnit } from "@covertree/features";
import { SelectOption } from "@covertree/ui";
import { preciselyAddress } from "@covertree/utils";

export interface MailingAddressForm {
  address: SelectOption<PreciselyAddressWithUnit>;
  lotUnit?: string | null;
}

export const mailingAddressFormValidator = object({
  address: preciselyAddress(),
  lotUnit: string().optional().nullable(),
});
